module.exports = __webpack_public_path__ + "img/burger_menu.703ca0e3.svg";